export default function RequestDrawIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33337 9.1667C6.33337 9.81336 6.83338 10.3334 7.44672 10.3334H8.70003C9.23337 10.3334 9.66671 9.88003 9.66671 9.31336C9.66671 8.7067 9.40005 8.4867 9.00671 8.3467L7.00004 7.6467C6.60671 7.5067 6.34005 7.29337 6.34005 6.68003C6.34005 6.12003 6.77337 5.66003 7.3067 5.66003H8.56004C9.17337 5.66003 9.67338 6.18003 9.67338 6.8267"
        stroke="#FDFDFD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 5V11" stroke="#3B4567" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.6667 8.00004C14.6667 11.68 11.68 14.6667 8.00004 14.6667C4.32004 14.6667 1.33337 11.68 1.33337 8.00004C1.33337 4.32004 4.32004 1.33337 8.00004 1.33337"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 4.00004V1.33337H12"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3334 4.66671L14.6667 1.33337"
        stroke="#3B4567"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
